import * as Responsiveness from "./ui/responsiveness";
import * as SidebarBookmarks from "./sidebarBookmarks";
import * as SidebarEducations from "./sidebarEducations";
import * as SidebarMostVisited from "./sidebarMostVisited";
import * as SidebarNotes from "./sidebarNotes";
import { ScrollLock } from "./helpers/scrollLock";

export function initialize(): void {
  SidebarBookmarks.initialize();
  SidebarEducations.initialize();
  SidebarMostVisited.initialize();
  SidebarNotes.initialize();

  initializeCoverageMenuItem();

  wireBlockedElements();
  wireExpansion();
}

const initializeCoverageMenuItem = () => {
  $(".js-load-coverage").on("click", (event: any, params: any) => {

    $('.sidebar').addClass('sidebar--sub-level');
    $(".subNavigation").addClass("selected--coverage");
    $(".pIWatched").addClass("selectedItem");
    $("#mycoverage_sidebar").addClass("selectedItem").focus();

    $(".pIFavorites").hide();
    $(".pIEducations").hide();
    $(".pIUser").hide();
    $(".pINotes").hide();
    $(".pIRecentlyRead").hide();

    $("#mynotes_sidebar").removeClass("selectedItem");
    $("#mylatestvisited_sidebar").removeClass("selectedItem");
    $("#myfavorites_sidebar").removeClass("selectedItem");

  });
};

// Toggles visibility of menu item, i.e bookmark app
const toggleSideBarSubLevel = () => {
  $(".sidebar").toggleClass("sidebar--sub-level");
};

export const handleHideSideBarSubLevel = (menuClassName: string) => {
  document
    .getElementsByClassName(menuClassName)[0]
    .setAttribute("aria-pressed", "false");
  toggleSideBarSubLevel();
};

function wireExpansion() {
  $(".js-close-sidebar").on("click", close);
  $(".js-close-sidebar").on('keypress', (e) => {
    if(e.which == 13) {
        close(e);
        
    }
  });

  $(".sidebar").on("click", expand);
  /* Do not bind contract to body - will mess up React components in sidebar */
  window.addEventListener("click", contract);
  $("#mobile-sidebar-trigger").on("click", toggle);
  $(".mobile-sidebar-trigger").on("click", expand);
  addEscapeKeyListener();
  $("#sidebar-close-button").on("click", close);
}

function wireBlockedElements() {
  $(".js-block-function").click(onClickBlockedFunction);
}

function addEscapeKeyListener() {
  const personalLinks = document.querySelectorAll('.personal__link');

  document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
          let bookmarkModal = document.getElementsByClassName("bookmarks__modal");
          if ($(bookmarkModal).length) {
              let bookmarkModalCloseBtn = document.getElementsByClassName("bookmarks__modal-close-btn");
              $(bookmarkModalCloseBtn).click();
              $("#myfavorites_sidebar").focus();
          } else {
              close(event);
              personalLinks.forEach((link) => {
                  if (document.activeElement === link) {
                      close(null);
                      $(".pINotes").show();
                      $(".pIFavorites").show();
                      $(".pIUser").show();
                      $(".pIRecentlyRead").show();
                      $(".pIWatched").show();
                  }
              });
          }
      }
  });
}

function close(event) {
  if(!!event){
    event.preventDefault();
    event.stopPropagation();
  }
  const sidebarExpanded = $(".sidebar").hasClass('sidebar--expanded') ? true : false;

  $(".sidebar").removeClass("sidebar--expanded");
  const $this = $(this);
  const $sidebar = $(".sidebar");
  $(".mobile-sidebar-trigger").attr("aria-pressed", "false");
  $sidebar.removeClass("sidebar--sub-level").removeClass("sidebar--expanded");
  $(".personal__item").removeClass("selectedItem");
  $(".subNavigation").removeClass("selected--mostvisited");
  $(".subNavigation").removeClass("selected--notes");
  $(".subNavigation").removeClass("selected--bookmarks");
    if ($("#menuwrapper .personal__link").attr('aria-pressed') === 'true' || sidebarExpanded) {
      $("#menuwrapper .personal__link").focus();
  }
  ScrollLock.unlock();
}

function expand(event) {
  const $this = $(this);
  const contentID = $this.data("contentid");
  
  if(contentID && !!event){
    event.stopPropagation();
  }
    
  $(".mobile-sidebar-trigger").attr("aria-pressed", "false");
  $(".personal__item").removeClass("selectedItem");
  $(".personal__link").attr("aria-pressed", "false");

  const $sidebar = $(".sidebar");
  $(".sidebar").addClass("sidebar--expanded");
  $("." + contentID).show();
  $sidebar.removeClass("sidebar--sub-level").addClass("sidebar--expanded");
  //ScrollLock.lock();
}

function contract(event) {
  if (Responsiveness.smallerThan(Responsiveness.TABLET_LANDSCAPE)) {
    return;
  }
  if (
    typeof event.preventSidebarClosing !== "undefined" &&
    event.preventSidebarClosing
    ) {
      return;
    }

  if($(".sidebar").hasClass("sidebar--expanded")){
    $(".personal__item").removeClass("selectedItem");
    $(".subNavigation").removeClass("selected--bookmarks selected--mostvisited selected--coverage selected--notes");
    $(".pINotes").show();
    $(".pIFavorites").show();
    $(".pIUser").show();
    $(".pIRecentlyRead").show();
    $(".pIWatched").show();
  }

  $(".sidebar")
    .removeClass("sidebar--expanded")
    .find("[aria-pressed=true]")
    .attr("aria-pressed", "false");

}

function toggle() {
  const $this = $(this);
  const $sidebar = $(".sidebar");

  if ($this.hasClass("mobile-toolbar__sidebar-button--anonymous")) {
    document.location = $this.data("login");
    return;
  }

  if ($sidebar.hasClass("sidebar--expanded")) {
    $sidebar.removeClass("sidebar--sub-level").removeClass("sidebar--expanded");
    // $this.removeClass("mobile-toolbar__sidebar-button--open");
    ScrollLock.unlock();
  } else {
    $sidebar.removeClass("sidebar--sub-level").addClass("sidebar--expanded");
    // $this.addClass("mobile-toolbar__sidebar-button--open");
    $("#menubutton").attr("aria-pressed", "false");
    ScrollLock.lock();
  }
}

function onClickChatButton(e) {
  e.preventDefault();
  e.stopPropagation();
}

function onClickContactButton(e) {
  e.stopPropagation();
}

function onClickBlockedFunction(e) {
  e.preventDefault();

  const element = $(".sidebar-teaser");
  element.removeClass("animation--shake");
  setTimeout(() => {
    element.addClass("animation--shake");
  }, 200);

  $("#sidebarloginfield").focus();
}
